/**
 * page_view (spec §1).
 *
 * The SDK already fires a bare `page_view` of its own on load. We deliberately keep it
 * — the pixel is not modified — and emit an enriched one alongside; downstream queries
 * take the enriched stream by filtering on `properties.session_id IS NOT NULL`.
 */

/**
 * `isEntry` comes from the bootstrap, which reads it before anything else touches the
 * session — by the time this runs the first diagnostic event has already created it,
 * so asking again would always answer "not new".
 */
export function collectPageView(tracker, { doc = document, win = window, isEntry = false } = {}) {
  const context = tracker.context;

  tracker.track('page_view', {
    page_title: doc.title,
    page_url: win.location ? win.location.href : '',
    referrer: doc.referrer || null,
    is_entry: Boolean(isEntry),
    landing_id: context.landing_id || undefined,
  });
}
